import React from 'react';
import { motion } from 'framer-motion';
import { BoxIcon } from 'lucide-react';
interface PriceItem {
  work: string;
  price: string;
}
interface PriceCategoryCardProps {
  icon: BoxIcon;
  code: string;
  title: string;
  items: PriceItem[];
  index: number;
}
export function PriceCategoryCard({
  icon: Icon,
  code,
  title,
  items,
  index
}: PriceCategoryCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.4,
    delay: index * 0.06,
    ease: 'easeOut'
  }} className="group relative bg-neutral-900/50 border border-white/10 hover:border-[#6B7A4A] transition-colors duration-200 p-6 flex flex-col" data-id="element-268" data-mp="2qhnt3ozzm0qh">
      {/* Corner brackets */}
      <div className="absolute top-0 left-0 w-3 h-3 border-t border-l border-[#6B7A4A]/40" data-id="element-269" data-mp="27kwehsve49sr" />
      <div className="absolute top-0 right-0 w-3 h-3 border-t border-r border-[#6B7A4A]/40" data-id="element-270" data-mp="2bmho95cmo7yq" />
      <div className="absolute bottom-0 left-0 w-3 h-3 border-b border-l border-[#6B7A4A]/40" data-id="element-271" data-mp="so7ucd0zyype" />
      <div className="absolute bottom-0 right-0 w-3 h-3 border-b border-r border-[#6B7A4A]/40" data-id="element-272" data-mp="nqpt78t81nry" />

      {/* Header */}
      <div className="flex items-start gap-4 mb-5 pb-5 border-b border-white/10" data-id="element-273" data-mp="12lw161bvnwnx">
        <div className="p-2.5 bg-[#6B7A4A]/10 border border-[#6B7A4A]/20 shrink-0" data-id="element-274" data-mp="xpx2nkwu4y9s">
          <Icon className="w-5 h-5 text-[#6B7A4A] transition-transform duration-200 group-hover:scale-110" data-id="element-275" data-mp="a02sjb3whnt8" />
        </div>
        <div className="flex-1 min-w-0" data-id="element-276" data-mp="4ydinysezg6q">
          <div className="font-['JetBrains_Mono'] text-[10px] text-zinc-500 tracking-widest mb-1" data-id="element-277" data-mp="jpw1e4cnrots">
            {code}
          </div>
          <h3 className="font-['Oswald'] text-lg font-semibold text-white uppercase tracking-wide leading-tight" data-id="element-278" data-mp="ex31puw1r6ok">
            {title}
          </h3>
        </div>
      </div>

      {/* Price list */}
      <ul className="space-y-3.5" data-id="element-279" data-mp="3ieux7j9e68ri">
        {items.map((item, i) => <li key={i} className="flex items-baseline justify-between gap-4" data-id="element-280" data-mp="byxfheeueg3y" data-mpi={i}>
            <span className="text-sm text-zinc-300 font-['Inter'] leading-snug" data-id="element-281" data-mp="fzhdslb5jpro">
              {item.work}
            </span>
            <span className="flex items-baseline gap-1 shrink-0 whitespace-nowrap" data-id="element-282" data-mp="krh6ptst1ier">
              <span className="font-['JetBrains_Mono'] text-[10px] text-zinc-500 uppercase" data-id="element-283" data-mp="pq2b85f3ao90">
                від
              </span>
              <span className="font-['Oswald'] text-base font-bold text-[#A3E635] tracking-wide" data-id="element-284" data-mp="3p68nzrt7yhtu">
                {item.price}
              </span>
            </span>
          </li>)}
      </ul>
    </motion.div>;
}